export const BILLING = 'BILLING';
export const BILLING_ORGANIZATION_MEMBER = 'BILLING_ORGANIZATION_MEMBER';

export const PRODUCT = 'PRODUCT';
export const COUPON = 'COUPON';
export const INVOICE = 'INVOICE';

export const SUBSCRIPTION = 'SUBSCRIPTION';
